import { createActionCreator } from "common/ReduxUtils";
import { InboundActionTypes } from "inbounds/store/InboundActionTypes";

export const setIsGeneratingShipments = createActionCreator<boolean>(
  InboundActionTypes.SET_IS_GENERATING_SHIPMENTS,
  "isGeneratingShipments"
);
